<template>
  <div class="other-meun">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ChannelTabMenu"
};
</script>

<style lang="stylus" scoped>
.other-meun
  display flex
  margin-left 25px
  font-size 16px
</style>
